import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import _ from 'lodash';
import * as actions from '../action';
import * as c from '../constant';

import ViewHistoryModal from '../modals/ViewHistoryModal';

function MachineryHistoryContainer({
  getHistoryList,
  machineryHistoryList,
  applicationId,
  isLoading,
}) {
  const setModal = useContext(ModalContext);

  const handleView = (dataInfo) => (e) => {
    e.preventDefault();

    setModal({
      title: 'View History',
      isOpen: true,
      content: (
        <ViewHistoryModal
          applicationId={
            dataInfo.attributes.rptax_machinery_application_id.toString() || ''
          }
          historyId={dataInfo.id}
        />
      ),
      modalSize: 'modal-lg',
    });
  };

  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    getHistoryList(applicationId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    getHistoryList(applicationId);
  }, [applicationId]);

  return (
    <div className="card-content-listing">
      <div className="card p-0 mr-2">
        {isLoading ? (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        ) : (
          <>
            <div className="row my-3 mx-2">
              <table className="css-table table table-borderless table-sm table-striped table-hover">
                <thead className="table-header">
                  <tr>
                    <td className="font-weight-bold">Previous TDN</td>
                    <td className="font-weight-bold">Previous Pin</td>
                    <td className="font-weight-bold">Previous Owner</td>
                    <td className="font-weight-bold">Previous Ass. Value</td>
                    <td />
                  </tr>
                </thead>
                <tbody>
                  {machineryHistoryList && machineryHistoryList.length <= 0 && (
                    <tr className="text-center">
                      <td className="history-color" colSpan="7">
                        No data
                      </td>
                    </tr>
                  )}
                  {machineryHistoryList &&
                    machineryHistoryList.map((item) => (
                      <tr key={item.id}>
                        <td>
                          <span className="history-color">
                            {_.get(item, 'attributes.tdn')}
                          </span>
                        </td>
                        <td>
                          <span className="history-color">
                            {_.get(item, 'attributes.pin')}
                          </span>
                        </td>
                        <td>
                          <span className="history-color">
                            {_.get(
                              item,
                              'included.machineryOwner.attributes.full_name'
                            )}
                          </span>
                        </td>
                        <td>
                          <span className="history-color">
                            {_.get(item, 'attributes.assessed_value')}
                          </span>
                        </td>
                        <td className="text-center">
                          <button
                            type="button"
                            onClick={handleView(item)}
                            className="btn-blank button-eye"
                          >
                            <i className="far fa-eye icon-view" />
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

MachineryHistoryContainer.defaultProps = {
  applicationId: '',
};

MachineryHistoryContainer.propTypes = {
  getHistoryList: PropTypes.instanceOf(Function).isRequired,
  machineryHistoryList: PropTypes.instanceOf(Array).isRequired,
  applicationId: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  // removeData: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  machineryHistoryList:
    _.get(api, `${c.GET_MACHINERY_HISTORY_LIST}.list`) || [],
  isLoading:
    _.get(api, 'loading', []).indexOf(c.GET_MACHINERY_HISTORY_LIST) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(MachineryHistoryContainer);
